import { t } from '@/utils/i18n'
import React, { useState } from 'react'
import styles from './SortModal.module.less'
import type { SortItem } from '@/types/product'
import { useCorpSettingStore } from "@/stores";
import { utils, productUtil } from '@/utils'
// 导入图片
import arrowDesc from '@/assets/img/icon/sort-arrow-desc.svg'
import arrowAsc from '@/assets/img/icon/sort-arrow-asc.svg'
import arrow from '@/assets/img/icon/sort-arrow.svg'

interface SortModalProps {
  top?: string
  position?: 'absolute' | 'sticky' | 'fixed'
  sortIndex: number | string
  sortDirection: string
  onToggleShowSortModal: () => void
  onChangeSort: (item: SortItem, index: number) => void
}

const { px2rem } = utils


const SortModal: React.FC<SortModalProps> = ({ top, position = 'absolute', sortIndex, sortDirection, onToggleShowSortModal, onChangeSort }) => {
  const { corpSetting } = useCorpSettingStore()
  const options = productUtil.initSortOptions(
    corpSetting.cloudProductSort,
    corpSetting.salesOn,
    corpSetting.salesSlipOn,
  ) // 初始化排序选项
  // 设置当前激活选项
  const activeSortIndex = sortIndex || options.sortActive.activeIndex
  const activeSortDirection = sortDirection || options.sortActive.sortDirection

  const [sortOptions, setSortOptions] = useState(options.sortOptions)
  const style = {
    position: position,
    top: top ? top : px2rem(60),
  }

  function handleChangeSort(e: React.MouseEvent, index: number) {
    e.stopPropagation()
    const item = sortOptions[index]
    const copySortOptions = Array.from(sortOptions)

    if (index === activeSortIndex) {
      item.sortDirection = item.sortDirection === 'DESC' ? 'ASC' : 'DESC'
    }

    copySortOptions.splice(index, 1, item)
    setSortOptions(copySortOptions)
    onChangeSort(item, index)
  }

  function ArrowIcon(index: number) {
    return index === activeSortIndex
      ? activeSortDirection === 'DESC'
        ? arrowDesc
        : arrowAsc
      : arrow
  }

  const SortItem = () => {
    return sortOptions.map((item, index) => {
      return (
        <div
          className={styles['product-sort-item']}
          key={index}
          onClick={(e) => handleChangeSort(e, index)}
        >
          <div
            className={
              styles['product-sort-item-name'] +
              ' ' +
              (activeSortIndex === index && item.hideDirection ? 'selected' : '')
            }
          >
            {t('按{{name}}排序', { name: item.name })}
          </div>
          {!item.hideDirection ? (
            <img
              className={styles['product-sort-item-icon']}
              src={ArrowIcon(index)}
              alt="sort"
            />
          ) : (
            ''
          )}
        </div>
      )
    })
  }

  return (
    <div
      className={styles['product-sort-modal']}
      style={style}
      onClick={onToggleShowSortModal}
    >
      <div className={styles['product-sort-container']}>
        <SortItem />
      </div>
    </div>
  )
}

export default SortModal
